import { TRACKING_SOURCE_NAME } from '../../helpers/constant';
export const DEFAULT_PIXEL_MESSAGE = `Please install the below Veritone Attribute Pixel code on your website either via Google Tag Manager or directly on the site to begin collecting web traffic data.

HTML Code for direct website implementation: <insert code>

Pixel URL for Google Tag Manager: <insert URL>`;

export const DEFAULT_GA_MESSAGE = `Please connect your Google Analytics GA4 account data in order to kick off attribution reporting.`;
export const DEFAULT_GBQ_MESSAGE = `Please connect your Google BigQuery (GBQ) project to Veritone Attribute in order to kick off attribution reporting.`;
export const DEFAULT_PIXEL_INVITE_MESSAGE = `Please install Veritone Attribute Pixel code on your website to begin collecting web traffic data.`
const defaultInviteMessageMap = {
  [TRACKING_SOURCE_NAME.PIXEL]: DEFAULT_PIXEL_INVITE_MESSAGE,
}
export const defaultEmailTemplateHashmap = (type, emailTemplates = []) => {
  const getEmailTemplateByType = emailTemplates && emailTemplates.find(item => item.instruction_type === type);
  if (!getEmailTemplateByType || !getEmailTemplateByType.form_template) {
    return '';
  };
  return getEmailTemplateByType.form_template;
};

export const INPUT_ERROR_MESSAGE = 'Email list cannot be empty';
export const EMPTY_MESSAGE_ERROR = 'Message cannot be blank';
export const EMAIL_LIMIT = 5;

export const CHARACTER_LIMIT = 750;
export const getDefaultEmailInfoByType = (type, emailTemplates = []) => ({
  emails: [],
  message: defaultInviteMessageMap[type] || '',
  template: defaultEmailTemplateHashmap(type, emailTemplates),
  emailError: '',
  emailValue: '',
  msgError: ''
});


export const getTemplateWithInvitation = (defaultTemplate = "", inviteTemplate) => {
  if (!inviteTemplate) return defaultTemplate;

  const lastClose = defaultTemplate.lastIndexOf("</td>");
  if (lastClose === -1) return defaultTemplate;

  const lastOpenStart = defaultTemplate.lastIndexOf("<td", lastClose);
  if (lastOpenStart === -1) return defaultTemplate;

  const tdOpenEnd = defaultTemplate.indexOf(">", lastOpenStart);
  if (tdOpenEnd === -1 || tdOpenEnd >= lastClose) return defaultTemplate;

  return (
    defaultTemplate.slice(0, tdOpenEnd + 1) +
    inviteTemplate +
    defaultTemplate.slice(lastClose)
  );
};